import script from "./CollectionsFormOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionsFormOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./CollectionsFormOrganism.css?vue&type=style&index=0&id=8227d192&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8227d192"]])

export default __exports__